export default "__VITE_ASSET__D0CCy9wd__"